import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { from, Observable, switchMap } from 'rxjs';

import { environment } from '@env/environment';
import { GUEST_CART_TOKEN, PUBLIC_RESOURCES, RES_TYPE } from './http.service';

import { isPlatformBrowser } from '@angular/common';
import Cookies from 'js-cookie';
import Session from 'supertokens-web-js/recipe/session';
import { SUPER_TOKENS_READY } from '../auth/super-tokens-ready.token';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  private localeId = inject(LOCALE_ID);
  private platformId = inject(PLATFORM_ID);
  // Awaits SuperTokens init before calling Session APIs (P0-11 / F-2).
  // Default is `Promise.resolve()` for admin/SSR; marketplace overrides
  // with the readiness promise from AuthenticationService.
  private readonly superTokensReady = inject(SUPER_TOKENS_READY);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('@assets') && /@assets/.test(request.url)) {
      // This url replace for internal fetch
      request = request.clone({ url: request.url.replace('@assets', 'assets') });
    } else {
      if (!/^(http|https):/i.test(request.url)) {
        let language = '';
        if (isPlatformBrowser(this.platformId)) {
          language = Cookies.get('lang') ?? this.localeId;
        }
        request = request.clone({
          url: environment.serverUrl + request.url,
          ...((this.localeId && { headers: request.headers.set('accept-language', language.slice(0, 2)) }) || {}),
          withCredentials: true,
        });

        // Custom header
        if (request.context.get(GUEST_CART_TOKEN)) {
          request = request.clone({
            headers: request.headers.set('x-gt', request.context.get(GUEST_CART_TOKEN)),
          });
          return next.handle(request);
          // return this.credentialsService.getToken().pipe(
          //   switchMap((token) => {
          //     if (token) {
          //       request = request.clone({
          //         headers: request.headers.set('Authorization', 'Bearer ' + token),
          //       });
          //       request = request.clone({
          //         headers: request.headers.set('x-gt', request.context.get(GUEST_CART_TOKEN)),
          //       });
          //     } else {
          //       request = request.clone({
          //         headers: request.headers.set('x-gt', request.context.get(GUEST_CART_TOKEN)),
          //       });
          //     }
          //     return next.handle(request);
          //   })
          // );
        }

        if (request.context.get(RES_TYPE)) {
          return from(this.superTokensReady.then(() => Session.doesSessionExist())).pipe(
            switchMap((exists) => {
              if (exists) {
                // SuperTokens handles sending tokens via cookies
                request = request.clone({
                  headers: request.headers.set('accept', 'text/csv, application/json, */*'),
                });
                request = request.clone({
                  responseType: 'text' as 'json', // Set responseType for CSV
                });
              }
              return next.handle(request);
            })
          );
          // return this.credentialsService.getToken().pipe(
          //   switchMap((token) => {
          //     if (token) {
          //       request = request.clone({
          //         headers: request.headers.set('Authorization', 'Bearer ' + token),
          //       });
          //       request = request.clone({
          //         headers: request.headers.set('accept', 'text/csv, application/json, */*'),
          //       });
          //       request = request.clone({
          //         responseType: 'text' as 'json', // Set responseType for CSV
          //       });
          //     }
          //     return next.handle(request);
          //   })
          // );
        }

        if (!request.context.get(PUBLIC_RESOURCES)) {
          return next.handle(request);
          // return this.credentialsService.getToken().pipe(
          //   switchMap((token) => {
          //     if (token) {
          //       request = request.clone({
          //         headers: request.headers.set('Authorization', 'Bearer ' + token),
          //       });
          //     }

          //     return next.handle(request);
          //   })
          // );
        }
      }
    }

    return next.handle(request);
  }
}
